<template>
   <div
      class="min-h-screen bg-white flex flex-col"
      style="
         padding-top: env(safe-area-inset-top);
         padding-bottom: env(safe-area-inset-bottom);
      "
   >
      <header class="w-full px-4 py-3">
         <LayoutUnAuthHeader />
      </header>

      <main class="flex-1 flex items-center justify-center px-6">
         <div class="w-full">
            <NuxtPage />
         </div>
      </main>
   </div>
</template>